import { Box, IconButton } from "@material-ui/core"
import Close from "@material-ui/icons/Close"
import Search from "@material-ui/icons/Search"
import type { ReactElement } from "react"
import { SearchBar } from "../../organisms"

import "./search-widget.styles.scss"

export interface ISearchWidgetProps {
  disableClose?: boolean
  open: boolean
  onOpen: () => void
  onClose: () => void
}

export function SearchWidget(props: ISearchWidgetProps): ReactElement {
  const { disableClose, open, onOpen, onClose } = props

  function handleToggle(): void {
    open ? onClose() : onOpen()
  }

  return (
    <Box className="search-widget">
      {open || disableClose ? (
        <Box className="search-widget-search-container">
          {!disableClose && (
            <IconButton onClick={handleToggle}>
              <Close />
            </IconButton>
          )}
          <SearchBar />
        </Box>
      ) : (
        <IconButton onClick={handleToggle}>
          <Search />
        </IconButton>
      )}
    </Box>
  )
}
